import { render, staticRenderFns } from "./IndicationComments.vue?vue&type=template&id=dcb7506c&scoped=true"
import script from "./IndicationComments.vue?vue&type=script&lang=js"
export * from "./IndicationComments.vue?vue&type=script&lang=js"
import style0 from "./IndicationComments.vue?vue&type=style&index=0&id=dcb7506c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb7506c",
  null
  
)

export default component.exports